import { render, staticRenderFns } from "./mobile_trading_login.vue?vue&type=template&id=38a8edaa&scoped=true&"
import script from "./mobile_trading_login.vue?vue&type=script&lang=js&"
export * from "./mobile_trading_login.vue?vue&type=script&lang=js&"
import style0 from "./mobile_trading_login.vue?vue&type=style&index=0&id=38a8edaa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a8edaa",
  null
  
)

export default component.exports